// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3sPb1","signatureBlock":"Footer_signatureBlock__4W9cd","signature":"Footer_signature__3paCP"};